module.exports = __webpack_public_path__ + "img/52.c4667736.jpg";